<template>
  <el-container class="train-index-container">
    <el-header>
      <Header title="鹿客竞练管理后台"></Header>
    </el-header>
    <div class="slide-img">
      <div class="classroom-info">
        <div class="classroom-desc" v-if="trains">
          <img :src="trains.cover.middle?common.filepath(trains.cover.middle):require('../../assets/imgs/default-icon.jpg')" class="classroom-avatar" />
          <h1>
            {{trains.title}}
          </h1>
          <div class="desc" id="desc" v-html="trains.intro"></div>
        </div>
      </div>
    </div>
    <div class="train-header">
      <el-tabs type="card" @tab-click="handleClick" v-model="activeName">
        <template v-for="(item,index) in items.project">
          <el-tab-pane :label="item.project_name" :name="`project`+index"  :key="index"></el-tab-pane>
        </template>
      </el-tabs>
    </div>
    <el-main class="train-container">
      <div class="train-box">
        <div class="project-box" v-for="(element,ind) in items.project" :id="`project-box`+ind" :key="ind">
          <div class="project-box-header">
            <span class="square-dot"></span>
            <span class="project-title">{{element.project_name}}</span>
            <span>共{{element.task.length}}项</span>
          </div>
          <div class="project-rate">
            <span style="font-weight:bold;">我的通过率：</span>

            <el-radio-group v-model="pass[ind]" @change="changeHandleClick(ind)">
              <el-radio :label="1">全部</el-radio>
              <el-radio :label="2">80%以上</el-radio>
              <el-radio :label="3">50%-79%</el-radio>
              <el-radio :label="4">1%-49%以上</el-radio>
              <el-radio :label="5">未练习</el-radio>
            </el-radio-group>
            <div class="pro-progress" style="">
              <el-progress :percentage="element.progress" stroke-linecap="square" :stroke-width="10">123</el-progress>
            </div>
          </div>
          <template v-for="(it,idx) in element.task">
            <div class="task-box" @click="jumpItemList(it.id)" :data-rate="it.pass_rate" :key="idx">
              <div class="task-title">{{it.task_name}}</div>
              <div class="task-num">
                <span>{{it.event_num?it.event_num:0}}个活动</span>
                <i></i>
                <span>{{it.num?it.num:0}}人练习</span>
              </div>
              <div class="task-pass">
                <div class="task-pass-item">
                  <span>{{it.done?it.done:0}}</span>已挑战
                </div>
                <div class="task-pass-item">
                  <span>{{it.pass_num?it.pass_num:0}}</span>已通过
                </div>
                <div class="task-pass-item">
                  <span>{{it.pass_rate?it.pass_rate:0}}%</span>通过率
                </div>
              </div>
            </div>
          </template>
          <div :id="`empty-tip-mod`+ind" class="empty-tip-mod hide">
            暂无练习数据，继续加油
          </div>
          <div style="clear:both;"></div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import Header from "@/layouts/app/Header";
import {
  selectTrainData
} from "@/api/show";
export default {
  components: {
    Header,
  },
  data() {
    return {
      items: [],
      competitionId: "", //训练id
      replay_type: 1,//是正常训练还是专题进入的训练,1为正常，2为专题进入
      trains: null,//应用名称
      pass: [],
      pass_rate: 1,
      activeName: 'project0',
    }
  },
  mounted() {
    this.competitionId = this.$route.params.competitionId;
    this.initData()
    sessionStorage.removeItem('competitionId')
    sessionStorage.removeItem('taskId')
    this.$nextTick(function () {
      window.addEventListener('scroll', this.onScroll)
    })
  },
  watch: {
  },
  methods: {
    initData: function () {
      let params = {
        competition_id: this.competitionId,
        replay_type: this.replay_type
      };
      selectTrainData(params).then(response => {
        this.items = response.data
        this.trains = response.trains
        this.packageRate(this.items.project)
      });
    },
    //封装通过率组合
    packageRate: function (data) {
      data.forEach((element, index) => {
        this.pass[index] = 1;
      });
    },
    jugeRate: function (rate, index) {
      if (this.pass[index] === 1) {
        return true;
      } else if (this.pass[index] === 2) {
        if (rate >= 80) {
          return true;
        }
      } else if (this.pass[index] === 3) {
        if (rate >= 50 && rate < 80) {
          return true;
        }
      } else if (this.pass[index] === 4) {
        if (rate >= 1 && rate < 50) {
          return true;
        }
      } else if (this.pass[index] === 5) {
        if (rate == 0) {
          return true;
        }
      }
    },

    changeHandleClick: function (ind) {
      let projectBox = document.getElementById('project-box' + ind).getElementsByClassName('task-box');
      let num = 0;
      for (let i = 0; i < projectBox.length; i++) {
        let rate = projectBox[i].getAttribute('data-rate');
        if (this.jugeRate(rate, ind)) {
          num++;
          projectBox[i].classList.remove('hide')
        } else {
          projectBox[i].classList.add('hide')
        }
      }
      if (num) {
        document.getElementById('empty-tip-mod' + ind).classList.add('hide')
      } else {
        document.getElementById('empty-tip-mod' + ind).classList.remove('hide')
      }
    },
    //跳转活动列表页面
    jumpItemList: function (id) {
      this.$router.push({ name: 'train-item-list', params: { competitionId: this.competitionId, taskId: id } })
    },
    handleClick: function (tab, event) {
      let index = tab.index
      let jump = document.getElementsByClassName('project-box');
      // 获取需要滚动的距离
      let total = jump[index].offsetTop - 100;
      // Chrome
      document.body.scrollTop = total;
      // Firefox
      document.documentElement.scrollTop = total;
      // Safari
      window.pageYOffset = total;
      this.activeName = 'project' + index;
    },
    onScroll() {
      let scrolled = document.documentElement.scrollTop || document.body.scrollTop
      let fixed_header = document.getElementsByClassName("train-header");
      if (!fixed_header.length) {
        return true;
      }
      let el_header = document.getElementsByClassName("el-header");
      if (scrolled >= 80) {
        fixed_header[0].classList.add("active");
        el_header[0].classList.add("active");
      } else if (scrolled < 50) {
        fixed_header[0].classList.remove("active");
        el_header[0].classList.remove("active");
      }
      let tabs = document.getElementsByClassName("project-box");
      for (let i = 0; i < tabs.length; i++) {
        let top = tabs[i].offsetTop;
        if (i > 0) {
          top -= 100;
        }
        if (scrolled >= top) {
          this.activeName = 'project' + i;
        }
      }
    },
  },
}
</script>
<style scoped>
.train-container {
  width: 1000px;
  margin: auto;
  display: block;
}
.train-header {
  border-bottom: 1px solid #dce1e6;
  background-color: #e7eef3;
  margin: auto;
  width: 100%;
}
.train-header i {
  font-size: 20px;
  position: relative;
  top: 3px;
  margin: 0 5px;
}
.train-header /deep/ .el-tabs {
  width: 1000px;
  margin: auto;
}
.train-header /deep/ .el-tabs__header {
  margin: 0;
  border: none;
}
.train-header /deep/ .el-tabs__content {
  visibility: hidden;
}
.target-title {
  font-size: 18px;
  font-weight: bold;
  margin: 15px 0;
}
.project-box-header {
  margin: 15px 0 0 0;
}
.square-dot {
  width: 5px;
  height: 5px;
  display: inline-block;
  background-color: red;
  margin: 3px;
}
.project-box-header .project-title {
  margin-right: 15px;
  font-size: 16px;
  font-weight: bold;
}
.project-rate {
  margin: 10px 0;
}
.pro-progress {
  display: inline-block;
  width: 200px;
  float: right;
}
.task-box {
  width: 230px;
  height: 160px;
  border: 1px solid #dce1e6;
  float: left;
  margin: 10px 13px 10px 0;
  box-sizing: border-box;
  border-radius: 3px;
  cursor: pointer;
}
.task-box:nth-child(5n + 1) {
  margin: 10px 0;
}
.task-box .task-title {
  height: 48px;
  line-height: 48px;
  padding: 0 10px;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.task-box .task-num {
  height: 48px;
  line-height: 48px;
  padding: 0 10px;
  box-sizing: border-box;
  position: relative;
  background-color: #e7eef3;
}
.task-box .task-num span {
  display: inline-block;
  width: 50%;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.task-box .task-num i {
  display: block;
  position: absolute;
  top: 10px;
  left: 50%;
  height: 50%;
  width: 0;
  border-right: 1px solid #acafb3;
}
.task-box .task-pass {
  padding: 10px;
  box-sizing: border-box;
  height: 62px;
  display: flex;
}
.task-box .task-pass .task-pass-item {
  text-align: center;
  width: 33.33%;
  border-right: 1px solid #dce1e6;
}
.task-box .task-pass .task-pass-item span {
  display: block;
  width: 100%;
  line-height: 25px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.task-box .task-pass .task-pass-item:last-child {
  border-right: none;
}
.train-index-container .el-header {
  height: auto;
}
.train-index-container .el-header.active {
  position: fixed;
  width: 100%;
  z-index: 999;
  background-color: #ffffff;
  padding: 0;
}
.train-header.active {
  width: 100%;
  margin: auto;
  position: fixed;
  top: 60px;
  z-index: 99;
}
.train-header.active /deep/ .el-tabs {
  width: 1000px;
  margin: auto;
  background-color: #e7eef3;
}
.train-header /deep/ .el-tabs--card > .el-tabs__header .el-tabs__item {
  border: none;
}
.train-header
  /deep/
  .el-tabs--card
  > .el-tabs__header
  .el-tabs__item.is-active {
  background-color: #ffffff;
  border-bottom: 1px solid #dce1e6;
  color: #000000;
}
.train-header.active
  /deep/
  .el-tabs--card
  > .el-tabs__header
  .el-tabs__item.is-active {
  background-color: #ffffff;
}
.empty-tip-mod {
  text-align: center;
  font-size: 14px;
  padding: 50px 0;
}
.hide {
  display: none;
}
.slide-img {
  width: 100%;
  height: 200px;
  position: relative;
  background-image: url(../../assets/imgs/bg.png);
  background-repeat: no-repeat;
  background-size: cover;
}
.classroom-info {
  width: 1000px;
  height: 200px;
  margin: auto;
  box-sizing: border-box;
  color: #ffffff;
  position: relative;
}

.classroom-desc {
  display: inline-block;
  height: 100%;
  position: relative;
  padding: 30px 150px;
  box-sizing: border-box;
}
.classroom-desc h1 {
  font-size: 2rem;
  height: 40px;
  margin-bottom: 10px;
}
.classroom-desc h1 i {
  font-size: 20px;
  position: relative;
  top: -10px;
  right: -10px;
  cursor: pointer;
}
.classroom-desc .desc {
  height: calc(100% - 40px);
  overflow: auto;
}
.classroom-desc p {
  line-height: 30px;
}
.classroom-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  position: absolute;
  top: 40px;
  left: 15px;
}
</style>